import { useState, useEffect } from 'react';
import { useThemeSwitcher } from 'react-css-theme-switcher';

import doReturnTheme from '~src/styles/themeEngine';
import { EStyleObj } from '~src/types';

export const useStyles = (styleFn: ThemedStyleFn) => {
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);
  const [styles, setStyles] = useState(styleFn(theme));

  useEffect(() => {
    setStyles(styleFn(theme));
  }, [theme, styleFn]);

  return styles;
};

export type ThemedStyleFn = (
  theme: ReturnType<typeof doReturnTheme>
) => EStyleObj;
